"use client"
import { TRAVEL_AGENT_ROLE } from "constant"
import { selectUser } from "stores/auth/authSlice"
import { useAppSelector } from "stores/hooks"

import { isClientPreviewActive } from "./previewMode"

/**
 * Hook to determine if the current user is a travel agent.
 * Returns `true` if `user.userRole === "TRAVEL_AGENT"`.
 *
 * When the URL contains `?preview=client`, the agent is treated as a
 * non-agent so they can preview the page as their client would see it.
 */
export function useIsAgent() {
  const user = useAppSelector(selectUser)

  if (isClientPreviewActive()) return false
  return user?.userRole === TRAVEL_AGENT_ROLE
}
